
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.997 14.5a1 1 0 011 1v7.586l2.296-2.295a1 1 0 111.414 1.414l-4.003 4.002a1 1 0 01-1.414 0l-3.997-3.997a1 1 0 011.414-1.414l2.29 2.29V15.5a1 1 0 011-1zM13.091 1.504c.5.01.791.044 1.114.118.405.093.772.245 1.124.466.356.222.63.456 1.192 1.02l4.872 4.87c.563.564.797.837 1.02 1.193.22.352.372.719.465 1.124.074.323.107.614.118 1.114.003.03.004.06.004.091v.533a1 1 0 01-2 0V11.5h-5.5A2.5 2.5 0 0113 9l.002-5.497-.176-.002-2.135-.001c-2.334 0-3.018.212-3.678.565a3.465 3.465 0 00-1.448 1.448C5.212 6.173 5 6.857 5 9.19v8.618c0 2.334.212 3.018.565 3.678.336.627.821 1.113 1.448 1.448.66.353 1.344.565 3.678.565h1.618c.24 0 .462-.002.67-.007a1 1 0 01.043 2c-.224.005-.462.007-.713.007H10.69c-2.447 0-3.526-.216-4.622-.802a5.465 5.465 0 01-2.267-2.267C3.216 21.335 3 20.256 3 17.809V9.19c0-2.447.216-3.526.802-4.622a5.465 5.465 0 012.267-2.267c1.096-.586 2.175-.802 4.622-.802H13c.03 0 .061.001.09.004zM15 9a.5.5 0 00.41.492l.09.008 4.587.002-.108-.11-4.872-4.87L15 4.414V9z","fill":"currentColor"}})])
          )
        }
      }
    